import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import RecentSearchTile from './RecentSearchTile'
import { getRecentSearchUrl } from './recentSearchLinks'

interface Props {
  recentSearches: Array<App.FullRecentSearch>
  onClose: (recentSearch: App.FullRecentSearch) => void
}

function RecentSearchesCarousel(props: Props) {
  const { recentSearches, onClose } = props

  return <CardCarousel>
    {recentSearches.map((recentSearch, index) => (
      <RecentSearchTile
        recentSearch={recentSearch}
        key={index}
        onClose={onClose}
        to={getRecentSearchUrl(recentSearch)}
      />))}
  </CardCarousel>
}

export default RecentSearchesCarousel
